export const GOAL_OPTIONS = [
  { value: "protect-family", label: "Protect my family" },
  { value: "save-retirement", label: "Save for retirement" },
  { value: "tax-advantaged-growth", label: "Tax-advantaged growth" },
  { value: "plan-college", label: "Plan for college" },
  { value: "healthcare-costs", label: "Prepare for healthcare costs" },
  { value: "leave-legacy", label: "Leave a legacy" },
];

export const PRODUCT_INTERESTS = [
  { value: "term-life", label: "Term Life Insurance" },
  { value: "annuity-accumulation", label: "Annuity — Accumulation" },
  { value: "annuity-income", label: "Annuity — Income" },
  { value: "iul-accumulation", label: "Index Universal Life (Accumulation)" },
  { value: "iul-protection", label: "Index Universal Life (Protection)" },
  { value: "ltc", label: "Long-Term Care" },
  { value: "medicare", label: "Medicare" },
  { value: "health-marketplace", label: "Health Insurance Marketplace" },
  { value: "not-sure", label: "I'm not sure — recommend for me" },
];

export const MARITAL_OPTIONS = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
];

export const TIME_HORIZON_OPTIONS = [
  { value: "short", label: "Short-term (< 5 yrs)" },
  { value: "medium", label: "Medium (5–15 yrs)" },
  { value: "long", label: "Long-term (15 yrs+)" },
];

export const RISK_OPTIONS = [
  { value: "conservative", label: "Conservative" },
  { value: "balanced", label: "Balanced" },
  { value: "growth", label: "Growth" },
];

export const BEST_TIME_OPTIONS = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
  { value: "anytime", label: "Anytime" },
];

export const CONTACT_METHOD_OPTIONS = [
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "either", label: "Either" },
];

/* Build initial form state, prefilling from URL search params if present. */
export const buildInitialForm = (params) => {
  const get = (k) => (params && params.get ? params.get(k) : undefined);
  // Accept both ?products=a,b,c (plural) and ?product=a (singular).
  // Merge, trim, filter to known interests, and dedupe (preserving order).
  const productsParam = get("products") || "";
  const productParam = get("product") || "";
  const rawIds = `${productsParam},${productParam}`
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  const seen = new Set();
  const matched = [];
  for (const id of rawIds) {
    if (seen.has(id)) continue;
    if (!PRODUCT_INTERESTS.some((p) => p.value === id)) continue;
    seen.add(id);
    matched.push(id);
  }

  // age field may come via several keys depending on source calculator
  const age =
    Number(get("age") || get("current_age") || get("child_age") || "") || "";

  const income = Number(get("income") || get("annual_income") || "") || "";
  const goalParam = get("goal");
  const goals = goalParam && GOAL_OPTIONS.some((g) => g.value === goalParam)
    ? [goalParam]
    : [];

  return {
    life_stage_data: {
      age,
      marital_status: "married",
      dependents: 0,
      goals,
      time_horizon: "medium",
    },
    financial_data: {
      income,
      retirement_savings: "",
      existing_life_coverage: Number(get("existing_coverage") || "") || "",
      debt: "",
      monthly_savings: "",
      risk_comfort: "balanced",
    },
    product_interests: matched,
    contact: {
      full_name: "",
      email: "",
      phone: "",
      state: "",
      best_time: "anytime",
      contact_method: "either",
      notes: get("notes") || "",
      consent: false,
    },
  };
};

/* Pull all query params into a plain object — stored as source_context */
export const paramsToObject = (params) => {
  const out = {};
  if (!params || !params.forEach) return out;
  params.forEach((v, k) => {
    out[k] = v;
  });
  return out;
};
